<template>
    <header class="header-global">      
      <base-nav class="navbar-main" fixed="top" transparent type="" effect="light" expand>
        <a slot="brand" class="navbar-brand mr-lg-5" href="/">
          <img class="logo" src="../assets/images/header/logo.png">
        </a>

        <div class="row" slot="content-header" slot-scope="{closeMenu}">
          <div class="col-6 collapse-brand">
            <a href="/">
              <img class="logo" src="./../assets/images/header/logo.png">
            </a>
          </div>
          <div class="col-6 collapse-close">
            <close-button @click="closeMenu"></close-button>
          </div>
        </div>

        <ul class="navbar-nav align-items-lg-center ml-lg-auto">
          <li class="nav-item">
            <a class="btn" href="/about-mora" 
               data-toggle="tooltip">
              <span class="nav-link-inner--text">Về Mora</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="btn" href="/services" 
               data-toggle="tooltip">
              <span class="nav-link-inner--text">Dịch vụ</span>
            </a>
          </li>
          <li class="nav-item ">
            <a class="btn" href="/doi-ngu-tu-van" 
               data-toggle="tooltip">
              <span class="nav-link-inner--text">Tìm Cố vấn</span>                        
            </a>
          </li>                
          <li class="nav-item ">
            <a class="btn" href="/tro-thanh-co-van"
               data-toggle="tooltip">
              <span class="nav-link-inner--text">Trở thành Cố vấn</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="btn" href="https://blog.moranow.com/blog"
               data-toggle="tooltip" target="blank">
              <span class="nav-link-inner--text">Blog</span>
            </a>
          </li>              
          <base-dropdown tag="li" class="nav-item">
            <a slot="title" href="#" class="btn" data-toggle="dropdown tooltip" role="button">
                <span class="nav-link-inner--text">Tài khoản</span>
            </a>  
            <div v-if="isAuthenticated">
            <!--
              Wait to relese
              <router-link to='/my_appointment' class='dropdown-item'>Lịch hẹn</router-link>
            -->
              <router-link to="/reset_password" class="dropdown-item">Đổi mật khẩu</router-link>
              <a :href="'/edit_profile?id='+user_id" class="dropdown-item">Cập nhật thông tin</a>
              <button @click='logout()' class="dropdown-item">Đăng xuất</button>
            </div>
            <div v-else>
              <router-link to="/login" class="dropdown-item">Đăng nhập</router-link>
              <router-link to="/register" class="dropdown-item">Đăng ký</router-link>
              <router-link to="/dang-ky-lam-co-van" class="dropdown-item">Đăng ký làm Cố vấn</router-link>  
            </div>
            <!-- <div>{{isAuthenticated}}</div>-->
          </base-dropdown>
          <li class="nav-item decorate-special">
            <a class="btn" href="/contact_us"
               data-toggle="tooltip">
              <span class="nav-link-inner--text">Hỗ trợ ngay</span>
            </a>
          </li>
        </ul>
      </base-nav>
    </header>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import cookie from 'vue-cookie';

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  computed:{    
    ...mapGetters( 'user', [
        'isAuthenticated'
    ]),
    ...mapState('user',{
      user_id: state => {
        var user = JSON.parse(state.user)
        return (user.id)
      },
    }),
  },
  methods: {
    ...mapActions('user', [
      'logout'
    ]),
  },
  mouted(){
    this.$store.watch('user',
    (state, getter) => state.user,
    (new_val, old_val) => {
      // console.log(new_val)
    }
    )
  },
  watch:{
    '$store.users.state': function(new_val, old_val){
    }
  },
  created: () =>{    
  },
  mouted:()=>{    
  }
};

</script>
<style lang="scss" scoped>  
  header.header-global{
    nav.navbar-main{
      position: fixed;
      background-color: #062d39;
      a.navbar-brand{
        img.logo{
            height: 20px;
            max-width: 150px;
        }
      }
      .row{
        .collapse-brand{
          a{
            img.logo{
              height: 20px;
              max-width: 150px;
            }                    
          }
        }
      }
    }
  }
  .nav-item{
    margin-right: 0px;
  }
  .btn{
    padding: 10px 10px;
  }
  span.nav-link-inner--text{
    color: #f1ab00;
  }
  .btn{
    text-transform: none;
  }
  .navbar-toggler{
    background-color: #f2a33b;
  }
  li.decorate-special{
    background-color: #f2a33b;
    border-radius: 5px;
    a{
      span{
        color: #FFFFFF;    
      }
    }
    :hover{
      background-color: #FFFFFF;
      color: #f2a33b;
    }    
  }
</style>



// WEBPACK FOOTER //
// src/layout/AppHeader.vue